import { createFileRoute } from '@tanstack/react-router'

import { useShellClient } from '@/components/clients/shell-client'
import { Frame } from '@/components/frame'
import { SegmentedControl } from '@/components/segmented-control'
import { PronunciationGlossaryEditor } from '@/components/training/pronunciation-glossary'
import { TrainingList } from '@/components/training/training-list'
import { exactly, readSearch } from '@/lib/search-params'

const SHAPE = {
  /** Lot 38a : le glossaire de prononciation du client. */
  onglet: exactly('glossaire'),
}

export const Route = createFileRoute('/_app/clients/$clientId/formations')({
  validateSearch: (search: Record<string, unknown>) => readSearch(SHAPE, search),
  component: ClientTrainingsPage,
})

function ClientTrainingsPage() {
  const client = useShellClient()
  const { onglet } = Route.useSearch()
  const navigate = Route.useNavigate()
  return (
    <Frame>
      <div className="space-y-4">
        <SegmentedControl
          label="Formations"
          value={onglet ?? 'scenarios'}
          options={[
            { value: 'scenarios', label: 'Scénarios' },
            { value: 'glossaire', label: 'Glossaire de prononciation' },
          ]}
          onChange={(next) => {
            void navigate({ search: next === 'glossaire' ? { onglet: 'glossaire' } : {} })
          }}
        />
        {onglet === 'glossaire' ? (
          <PronunciationGlossaryEditor clientId={client.id} />
        ) : (
          <TrainingList clientId={client.id} />
        )}
      </div>
    </Frame>
  )
}
